if (window?.pvs?.initLightbox) {
	pvs.initLightbox({ zIndex: 9999 });
}
